import PrivateRoute from 'utils/privateRoute';
import ProductCatalogOverview from 'components/ProductCatalogObs/OverviewTab';
import ProductCatalogRenewals from 'components/ProductCatalogObs/RenewalsTab';
import DataQualityRiskTab from 'components/ProductCatalogObs/DataQuality&RiskTab';
import ProductDetails from 'components/ProductCatalogObs/ProductDetails';


const ProductCatalogObsRoutes = [
    {
        key: 'prod_catalog_overview',
        route: '/productCatalog/overview',
        component: (
            <PrivateRoute
                Component={ProductCatalogOverview}
                restrictedRoles={[]}
            />
        )
    },
    {
        key: 'prod_catalog_data_quality_and_risk',
        route: '/productCatalog/data-quality-and-risk',
        component: (
            <PrivateRoute
                Component={DataQualityRiskTab}
                restrictedRoles={[]}
            />
        )
    },
    {
        key: 'prod_catalog_renewals',
        route: '/productCatalog/renewals',
        component: (
            <PrivateRoute
                Component={ProductCatalogRenewals}
                restrictedRoles={[]}
            />
        )
    },
    {
        key: 'prod_catalog_renewals_details',
        route: '/productCatalog/renewals/:id',
        component: (
            <PrivateRoute
                Component={ProductDetails}
                restrictedRoles={[]}
            />
        )
    }
];

export default ProductCatalogObsRoutes;
